package com.bulut.mecitogullari.di

import com.bulut.mecitogullari.core.network.createHttpClient
import com.bulut.mecitogullari.core.network.createJson
import com.bulut.mecitogullari.core.storage.AppStorage
import com.bulut.mecitogullari.core.storage.SettingsAppStorage
import com.bulut.mecitogullari.data.repository.AuthRepository
import com.bulut.mecitogullari.data.repository.BarterRepository
import com.bulut.mecitogullari.data.repository.DebtRepository
import com.bulut.mecitogullari.data.repository.FirebaseAuthRepository
import com.bulut.mecitogullari.data.repository.FirestoreBarterRepository
import com.bulut.mecitogullari.data.repository.FirestoreDebtRepository
import com.bulut.mecitogullari.data.repository.FirestoreNotesRepository
import com.bulut.mecitogullari.data.repository.FirestoreProfileRepository
import com.bulut.mecitogullari.data.repository.FirestoreProjectRepository
import com.bulut.mecitogullari.data.repository.FirestoreTransactionRepository
import com.bulut.mecitogullari.data.repository.FirestoreUnitRepository
import com.bulut.mecitogullari.data.repository.NotesRepository
import com.bulut.mecitogullari.data.repository.ProfileRepository
import com.bulut.mecitogullari.data.repository.ProjectRepository
import com.bulut.mecitogullari.data.repository.TransactionRepository
import com.bulut.mecitogullari.data.repository.UnitRepository
import com.bulut.mecitogullari.ui.screens.addtransaction.AddTransactionViewModel
import com.bulut.mecitogullari.ui.screens.craftsmandetail.CraftsmanDetailViewModel
import com.bulut.mecitogullari.ui.screens.craftsmen.CraftsmenViewModel
import com.bulut.mecitogullari.ui.screens.dashboard.DashboardViewModel
import com.bulut.mecitogullari.ui.screens.debts.DebtsViewModel
import com.bulut.mecitogullari.ui.screens.login.LoginViewModel
import com.bulut.mecitogullari.ui.screens.newproject.NewProjectViewModel
import com.bulut.mecitogullari.ui.screens.profile.ProfileViewModel
import com.bulut.mecitogullari.ui.screens.projectdetail.ProjectDetailViewModel
import com.bulut.mecitogullari.ui.screens.projects.ProjectsViewModel
import com.bulut.mecitogullari.ui.screens.purchase.PurchaseViewModel
import com.bulut.mecitogullari.ui.screens.reports.ReportsViewModel
import com.bulut.mecitogullari.ui.screens.supplierdetail.SupplierDetailViewModel
import com.bulut.mecitogullari.ui.screens.transactions.TransactionsViewModel
import com.russhwolf.settings.Settings
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

val networkModule = module {
    single { createJson() }
    single { createHttpClient(get()) }
}

/** Local key-value storage for lightweight device preferences. */
val storageModule = module {
    single<AppStorage> { SettingsAppStorage(Settings(), get()) }
}

/** All business data lives in Firestore under users/{uid}/... */
val repositoryModule = module {
    single<AuthRepository> { FirebaseAuthRepository() }
    single<TransactionRepository> { FirestoreTransactionRepository() }
    single<ProjectRepository> { FirestoreProjectRepository() }
    single<UnitRepository> { FirestoreUnitRepository() }
    single<NotesRepository> { FirestoreNotesRepository() }
    single<ProfileRepository> { FirestoreProfileRepository() }
    single<DebtRepository> { FirestoreDebtRepository() }
    single<BarterRepository> { FirestoreBarterRepository() }
}

val viewModelModule = module {
    viewModel { LoginViewModel(get()) }
    viewModel { DashboardViewModel(get(), get()) }
    viewModel { TransactionsViewModel(get(), get(), get()) }
    viewModel { (transactionId: String) -> AddTransactionViewModel(transactionId, get(), get(), get()) }
    viewModel { ReportsViewModel(get(), get()) }
    viewModel { ProfileViewModel(get(), get(), get(), get(), get()) }
    viewModel { ProjectsViewModel(get(), get(), get()) }
    viewModel { NewProjectViewModel(get(), get()) }
    viewModel { (projectId: String) -> ProjectDetailViewModel(projectId, get(), get(), get(), get()) }
    viewModel { DebtsViewModel(get()) }
    viewModel { (supplierId: String) -> SupplierDetailViewModel(supplierId, get()) }
    viewModel { (supplierId: String, entryId: String) -> PurchaseViewModel(supplierId, entryId, get()) }
    viewModel { CraftsmenViewModel(get(), get(), get()) }
    viewModel { (craftsmanId: String) -> CraftsmanDetailViewModel(craftsmanId, get(), get(), get()) }
}

val appModules = listOf(networkModule, storageModule, repositoryModule, viewModelModule)
